import React from 'react';
import { HomeIcon, LayoutDashboardIcon, MapIcon, TrophyIcon, ZapIcon } from 'lucide-react';
type NavBarProps = {
  currentScreen: string;
  onNavigate: (screen: string) => void;
};
export const NavBar: React.FC<NavBarProps> = ({
  currentScreen,
  onNavigate
}) => {
  const navItems = [{
    id: 'assessments',
    label: 'Assessments',
    icon: <LayoutDashboardIcon size={20} data-id="element-893" />
  }, {
    id: 'results',
    label: 'Results',
    icon: <HomeIcon size={20} data-id="element-894" />
  }, {
    id: 'journey',
    label: 'Journey',
    icon: <MapIcon size={20} data-id="element-895" />
  }, {
    id: 'leaderboard',
    label: 'Community',
    icon: <TrophyIcon size={20} data-id="element-896" />
  }, {
    id: 'challenge',
    label: 'Challenges',
    icon: <ZapIcon size={20} data-id="element-897" />
  }];
  return <nav className="bg-[#0A1128] border border-[#3A506B] rounded-lg p-1 flex justify-between" data-id="element-898">
      {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-md transition-all ${currentScreen === item.id ? 'bg-[#1C2541] text-[#7D56F4]' : 'text-[#B8C0E0] hover:bg-[#1C2541]/50'}`} data-id="element-899">
          {item.icon}
          <span className="text-xs mt-1" data-id="element-900">{item.label}</span>
        </button>)}
    </nav>;
};